<template>
  <div :class="getClassContainer()" v-on:click="callAction">
    <span :class="getClassIcon()" class="material-icons">{{ iconName }}</span>
    <div :class="getClasstext()" class="">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: "StandardButton",
  props: ["text", "iconName", "action", "disabled"],
  methods: {
    // callAction () {
    //   if (this.disabled) return
    //   this.action()
    // },
    callAction() {
        if (this.disabled) return;
        if (typeof this.action === 'function') {
            this.action();
        } else {
            console.warn('A função action não foi fornecida ou não é uma função');
        }
    },
    getClassContainer() {
      if (this.disabled) return "button-containear-disabled";
      else return "button-containear";
    },
    getClassIcon() {
      if (this.disabled) return "button-icon-disabled";
      else return "button-icon";
    },
    getClasstext() {
      if (this.disabled) return "button-text-disabled";
      else return "button-text";
    },
  },
};
</script>

<style scoped>
.button-containear {
  background-color: white;
  border: 0.5px solid #e5e5e5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 7.5vh;
  min-width: 12vw;
  padding: 0 1vw;
}
.button-containear-disabled {
  background-color: white;
  border: 0.5px solid #e5e5e5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 7.5vh;
  min-width: 12vw;
  padding: 0 1vw;
}
.button-containear:hover {
  background-color: var(--primary-color);
}
.button-containear:hover > .button-text {
  color: white;
}
.button-containear:hover > .button-icon {
  color: white;
}
.button-text {
  font-weight: 600;
  font-size: 1.1em;
  color: #202020;
}
.button-text-disabled {
  font-weight: 600;
  font-size: 14px;
  color: #e5e5e5;
}
.button-icon {
  color: var(--primary-color);
  margin-right: 10px;
}
.button-icon-disabled {
  color: #e5e5e5;
  margin-right: 10px;
}
</style>
